import React from "react";
import styled from "styled-components";
import { variables, colors, devices } from "../../assets/styles/variables";

const ButtonStyled = styled.button`
  border: 0px;
  border-radius: ${variables.smallRadius};
  background-color: ${colors.buttonPrimary};
  color: ${colors.buttonPrimaryText};
  font-size: ${variables.buttonSize};
  font-weight: 635;
  padding: 10px 15px;
  transition: all 0.3s ease-in-out;

  &:disabled { 
    background-color: ${colors.buttonPrimary} !important;
    color: ${colors.buttonPrimaryText};
    opacity: 0.7; 
  }

  &.pulse {
    box-shadow: 0 0 0 0 rgba(239, 67, 114, 0.4);
    -moz-animation: pulse 2s infinite;
    -webkit-animation: pulse 2s infinite;
    animation: pulse 2s infinite;
  }

  /* Bounce To Left */

  &.hvr-bounce-to-left {
    display: inline-block;
    vertical-align: middle;
    -webkit-transform: perspective(1px) translateZ(0);
    transform: perspective(1px) translateZ(0);
    position: relative;
    -webkit-transition-duration: 0.5s;
    transition-duration: 0.5s;
    z-index: 1;
  }
  
  &.hvr-bounce-to-left:before {
    border-radius: 15px;
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255,255,255,0.1);
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transform-origin: 100% 50%;
    transform-origin: 100% 50%;
    -webkit-transition-property: transform;
    -webkit-transition-property: -webkit-transform;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform, -webkit-transform;
    -webkit-transition-duration: 0.5s;
    transition-duration: 0.5s;
    -webkit-transition-timing-function: ease-out;
    transition-timing-function: ease-out;
  }
  
  // .hvr-bounce-to-left:hover, .hvr-bounce-to-left:focus, .hvr-bounce-to-left:active {
  //   // color: #000 !important;
  // }
  
  &.hvr-bounce-to-left:hover:before, .hvr-bounce-to-left:focus:before, .hvr-bounce-to-left:active:before {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
    -webkit-transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
    transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
  }

  &.secondary, &.secondary:disabled {
      background-color: ${colors.buttonSecondary} !important;
      color: ${colors.buttonSecondaryText};
  }
  &.dark, &.dark:disabled {
      background-color: ${colors.darkBlue} !important;
      color: ${colors.buttonSecondaryText};
  }
  &.white, &.white:disabled {
      background-color: ${colors.white} !important;
      color: ${colors.black};
  }
  &.glass, &.glass:disabled {
    background: rgba(255, 255, 255, 0.1); -webkit-backdrop-filter: blur(10px); backdrop-filter: blur(10px) !important;
  }
  &.small {
    font-size: ${variables.buttonSmallSize};
    line-height: ${variables.buttonSmallSize};
    font-weight: 400;
    padding: 8px 30px;
  }
  &:hover, &:active, &:visited {
    &.pulse {
      box-shadow: none;
      -moz-animation: none;
      -webkit-animation: none;
      animation: none;
    }
    background-color: ${colors.darkRed};
    &.secondary {
        background-color: ${colors.darkBlue};
    }
    &.white {
        color: ${colors.primary} !important;
    }
    &.dark {
        background-color: ${colors.black};
    }
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(239, 67, 114, 1);
    }
    70% {
      box-shadow: 0 0 0 5px rgba(239, 67, 114, 243, 0);
    }
    100% {
      box-shadow: 0 0 0 10px rgba(239, 67, 114, 0);
    }
  }

  @media (max-width: ${devices.sizeLaptop}) {
    width: 100%;
  }
`;

const Button = ({ className = '', secondary = false, dark = false, white = false, small = false, glass = false, ...rest}) => {
  return (
    <ButtonStyled className={`${glass ? 'glass ' : ''}${small ? 'small ' : ''}${secondary ? 'secondary ' : ''}${dark ? 'dark ' : ''}${white ? 'white ' : ''}${className}`}
      {...rest}
    />
  )
};

export default Button;